export const FREE_PLAN = {
  id: "00",
  price: 0,
  name: "Personal 👶",
  contacts: false,
  channels: 1,
  whitelabel: false,
  automessages: false,
  api: false,
  description: [
    "Unlimited conversations",
    "Unlimited operators",
    "Full widget customization"
  ]
}

export const PRO_PLAN_LAUNCH = {
  id: "01",
  price: 999,
  interval: 1,
  name: "Pro (Launch)",
  contacts: true,
  channels: Infinity,
  whitelabel: true,
  automessages: true,
  api: true,
  description: [
    "All the free tier features plus:",
    "Multiple widgets and sites",
    "Customizable auto-messages",
    "Email contacts w/ export",
    "Multiple Slack teams",
    "White-label chat widget"
  ]
}

export const PRO_PLAN_LEGACY = {
  id: "03",
  price: 1999,
  interval: 1,
  name: "Pro (Legacy)",
  contacts: true,
  channels: Infinity,
  whitelabel: true,
  automessages: true,
  api: true,
  description: [
    "All the free tier features plus:",
    "Multiple widgets and sites",
    "Customizable auto-messages",
    "Email contacts w/ export",
    "Multiple Slack teams",
    "White-label chat widget"
  ]
}

export const GROWTH_PLAN_MONTHLY = {
  id: "07",
  price: 1999,
  interval: 1,
  name: "Growth 😎",
  contacts: true,
  channels: 1,
  whitelabel: false,
  automessages: true,
  api: false,
  description: [
    "All free features plus:",
    "Custom auto messages",
    "Contacts list with export",
    "Unlimited visitors"
  ]
}

export const GROWTH_PLAN_ANNUALLY = {
  id: "04",
  price: 19190,
  interval: 12,
  name: "Growth 😎",
  contacts: true,
  channels: 1,
  whitelabel: false,
  automessages: true,
  api: false,
  description: [
    "All free features plus:",
    "Custom auto messages",
    "Contacts list with export",
    "Unlimited visitors"
  ]
}

export const BUSINESS_PLAN_MONTHLY = {
  id: "05",
  price: 3999,
  interval: 1,
  name: "Business 💼",
  contacts: true,
  channels: Infinity,
  whitelabel: true,
  automessages: true,
  api: true,
  description: [
    "All growth features plus:",
    "Multiple slack channels",
    "File uploads",
    "Whitelabel chat widget",
    "Javascript API"
  ]
}

export const BUSINESS_PLAN_ANNUALLY = {
  id: "06",
  price: 38390,
  interval: 12,
  name: "Business 💼",
  contacts: true,
  channels: Infinity,
  whitelabel: true,
  automessages: true,
  api: true,
  description: [
    "All growth features plus:",
    "Multiple slack channels",
    "File uploads",
    "Whitelabel chat widget",
    "Javascript API"
  ]
}



// WEBPACK FOOTER //
// ./src/account/billing/subscription-plans.js